import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { colors } from 'utils/colors'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const STabs = styled.div<{ swipeable?: boolean }>`
  display: flex;
  flex: 1;
  outline: none;
  border: 2px solid transparent;
  flex-direction: column;
  overflow: ${({ swipeable }) => (swipeable ? 'visible' : 'hidden')};
`

export const SHeaderRowTabs = styled.div({
  display: 'flex',
})

export const SHeaderRow = styled.div<{ swipeable?: boolean }>`
  display: flex;
  width: 100%;
  position: relative;
  justify-content: space-between;

  @media ${BREAKPOINTS.SM.max} {
    ${({ swipeable }) =>
      swipeable
        ? css`
            overflow-x: auto;
            margin: 0 calc(-1 * var(--min-space));
            padding: 0 var(--min-space);
            width: 100% + 2 * var(--min-space);
            scrollbar-width: none;

            &::-webkit-scrollbar {
              display: none;
            }
          `
        : null}
  }

  &:before {
    border-bottom: 2px solid ${colors.blue[100]};
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 1;
  }
`

export const SHeaderTab = styled.div<{ isSelected: boolean; swipeable?: boolean }>`
  border-bottom: 2px solid ${colors.blue[100]};

  ${(p) =>
    p.isSelected &&
    css`
      z-index: 2;
      border-bottom: 2px solid ${colors.blue[500]};

      & > span {
        font-weight: bold;
        color: black;
      }
    `}

  ${(p) =>
    p.swipeable &&
    css`
      & > span {
        white-space: nowrap;
      }
    `}

  padding: ${pxToRem(6)}rem ${pxToRem(12)}rem;
  cursor: pointer;
  @media ${BREAKPOINTS.MD.min} {
    padding: ${pxToRem(12)}rem ${pxToRem(24)}rem;
  }
`

export const STabContent = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: min-content;
  flex-direction: column;
`

export const SAction = styled.div`
  display: flex;
  align-self: center;
  justify-content: end;
  margin-left: 0rem;

  & > *:not(:last-child) {
    margin-right: 1rem;
  }

  @media ${BREAKPOINTS.MD.min} {
    margin-left: 1rem;
    & > *:not(:last-child) {
      margin-right: 2rem;
    }
  }
`
